module.exports = __webpack_public_path__ + "static/img/logo_t.ed1bc03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_t.png
// module id = 7mX5
// module chunks = 1